export default "__VITE_ASSET__DLp4R0KF__"